import { render, staticRenderFns } from "./techos_capitulos_dep.vue?vue&type=template&id=2a4d24c5&"
import script from "./techos_capitulos_dep.vue?vue&type=script&lang=ts&"
export * from "./techos_capitulos_dep.vue?vue&type=script&lang=ts&"
import style0 from "./techos_capitulos_dep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports